module.exports = __webpack_public_path__ + "img/bc7da45.svg";